export default "__VITE_ASSET__695f598d__"